import { Language } from '@ha/intl';

export function hasLanguage({ params: { lang = '' } }): boolean {
  return Object.values(Language).includes(lang.toLowerCase() as Language);
}
